/* eslint-disable no-unused-vars */
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import Loader from "../../../components/Loader";
import Input from "../../../components/UIComponents/Input";
import { Icon } from "@iconify/react";
import { InitialValues, validationSchema } from "./utils";
import ImageInput from "../../../components/UIComponents/ImageInput";
import { createTenant, updateTenant } from "../../../../services/TenantService";
import swal from "sweetalert";

const Flex = ({ children }) => {
  return (
    <div className="row gx-4">
      {React.Children.map(children, (child, index) => (
        <div className="col-6" key={index}>
          {child}
        </div>
      ))}
    </div>
  );
};

const TenantModal = (props) => {
  const formikRef = useRef();
  const [loading, setLoading] = useState(false);
  const [initialVals, setInitialVals] = useState(InitialValues);

  useEffect(() => {
    if (props.viewOrEdit !== "none") {
      const tempTenant = {
        Name: props?.selectedTenant?.Name,
        Sigle: props?.selectedTenant?.Sigle,
        address: props?.selectedTenant?.address,
        city: props?.selectedTenant?.city,
        country: props?.selectedTenant?.country,
        email: props?.selectedTenant?.email,
        expirationdate: props?.selectedTenant?.expirationdate,
        isocountry: props?.selectedTenant?.isocountry,
        logo: props?.selectedTenant?.logo,
        person_in_charge: props?.selectedTenant?.person_in_charge,
        phone: props?.selectedTenant?.phone,
        phone2: props?.selectedTenant?.phone2,
        selfregurl: props?.selectedTenant?.selfregurl,
        state: props?.selectedTenant?.state,
        website: props?.selectedTenant?.website,
        zip: props?.selectedTenant?.zip,
      };
      setInitialVals(tempTenant);
    } else {
      setInitialVals(InitialValues);
    }
  }, [props.viewOrEdit, props.selectedTenant]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    setLoading(true);
    try {
      if (props.viewOrEdit === "edit") {
        updateTenant(props?.selectedTenant?.id, values)
          .then((res) => {
            swal("Success", "Tenant Update successfully", "success");
            formikRef.current.resetForm();

            props.getAllRoles();
            props.onHideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        createTenant(values)
          .then((res) => {
            swal("Success", "Tenant Created successfully", "success");
            formikRef.current.resetForm();
            props.getAllRoles();
            props.onHideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.error(error);
      setSubmitting(false);
      setLoading(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleOnChange = (e) => {
    let id = e.target.value;
  };
  return (
    <Modal
      className="modal fade "
      dialogClassName="modal-90w"
      size="xl"
      backdrop="static"
      show={props.showAddModal}
      onHide={props.onHideModal}
    >
      <div className="" role="document">
        <div className="modal-header">
          <h4 className="modal-title fs-20">
            {props.viewOrEdit === "view"
              ? "View the Tenant"
              : props.viewOrEdit === "edit"
              ? "Update the Tenant"
              : "Add a New Tenant"}
          </h4>
          <button type="button" className="close btn" onClick={props.onHideModal}>
            <span>×</span>
          </button>
        </div>

        <Formik
          initialValues={initialVals}
          validationSchema={Yup.object(validationSchema)}
          onSubmit={handleSubmit}
          innerRef={formikRef}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form onChange={handleOnChange} className="m-4 ">
              {loading && <Loader forProcess={true} />}
              <Flex>
                <Input label="Name" name="Name" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="Sigle" name="Sigle" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>

              <Flex>
                <Input label="Address" name="address" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="City" name="city" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>

              <Flex>
                <Input label="State" name="state" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="Zip" name="zip" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>

              <Flex>
                <Input label="Country" name="country" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="Email" name="email" type="email" disabled={props.viewOrEdit === "view"} />
              </Flex>
              <Flex>
                <Input
                  label="Expiration Date"
                  name="expirationdate"
                  type="date"
                  disabled={props.viewOrEdit === "view"}
                />
                <Input label="ISO Country" name="isocountry" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>

              <Flex>
                {props.viewOrEdit !== "view" && <ImageInput label="Logo" name="logo" />}

                <Input
                  label="Person In Charge"
                  name="person_in_charge"
                  type="text"
                  disabled={props.viewOrEdit === "view"}
                />
              </Flex>
              <Flex>
                <Input label="Phone" name="phone" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="Phone 2" name="phone2" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>
              <Flex>
                <Input label="Self Reg Url" name="selfregurl" type="text" disabled={props.viewOrEdit === "view"} />
                <Input label="Website" name="website" type="text" disabled={props.viewOrEdit === "view"} />
              </Flex>

              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  disabled={isSubmitting || props.viewOrEdit === "view"}
                  className="btn btn-primary me-4"
                >
                  {isSubmitting ? <Icon icon="eos-icons:loading" className="text-[24px]" /> : "Confirm"}
                </button>
                <button onClick={props.onHideModal} type="reset" className="btn btn-primary">
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default TenantModal;
